var dataHelper = {
    getWorkType() {
        return [
            { id: 1, name: "微信" },
            { id: 2, name: "QQ" },
            { id: 9, name: "腾讯云" },
            { id: 3, name: "阿里云" },
            { id: 4, name: "数据库" },
            { id: 5, name: "码云" },
            { id: 6, name: "微博" },
            { id: 7, name: "微信公众平台" },

            { id: 10, name: "抖音号" },
            { id: 11, name: "小红书" },
            { id: 12, name: "百家号" },
            { id: 13, name: "博客" },

            { id: 8, name: "其他" }
        ];
    },
    getProjectState() {
        return [
            { id: 1, name: "未开始" },
            { id: 2, name: "开发中" },
            { id: 3, name: "使用中" },
            { id: 4, name: "已暂停" },
            { id: 11, name: "已关闭" }
        ];
    },
}


export default dataHelper;